// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/email_conversations.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact } from "./contacts_pb";
import { file_cortado_v1_contacts } from "./contacts_pb";
import type { EmailThreadLite, EmailThreadReviewReason } from "./emails_pb";
import { file_cortado_v1_emails } from "./emails_pb";
import type { EmailThreadLinkSourceEnum, ParentTypeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/email_conversations.proto.
 */
export const file_cortado_v1_email_conversations: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_contacts, file_cortado_v1_emails, file_cortado_v1_settings, file_google_protobuf_timestamp]);

/**
 * ListEmailThreadsByEntityRequest retrieves conversations linked to one CRM entity.
 *
 * @generated from message cortado.v1.ListEmailThreadsByEntityRequest
 */
export type ListEmailThreadsByEntityRequest = Message<"cortado.v1.ListEmailThreadsByEntityRequest"> & {
  /**
   * Organization whose conversations may be returned.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Type of entity linked to the conversations.
   *
   * @generated from field: cortado.v1.ParentTypeEnum entity_type = 2;
   */
  entityType: ParentTypeEnum;

  /**
   * Entity ID linked to the conversations.
   *
   * @generated from field: string entity_id = 3;
   */
  entityId: string;

  /**
   * Optional page size (defaults and maximum are enforced by the server).
   *
   * @generated from field: optional int32 limit = 4;
   */
  limit?: number;

  /**
   * Optional page offset.
   *
   * @generated from field: optional int32 offset = 5;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListEmailThreadsByEntityRequest.
 * Use `create(ListEmailThreadsByEntityRequestSchema)` to create a new message.
 */
export const ListEmailThreadsByEntityRequestSchema: GenMessage<ListEmailThreadsByEntityRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 0);

/**
 * ListEmailThreadsByEntityResponse returns linked conversations.
 *
 * @generated from message cortado.v1.ListEmailThreadsByEntityResponse
 */
export type ListEmailThreadsByEntityResponse = Message<"cortado.v1.ListEmailThreadsByEntityResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailThreadLite threads = 1;
   */
  threads: EmailThreadLite[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListEmailThreadsByEntityResponse.
 * Use `create(ListEmailThreadsByEntityResponseSchema)` to create a new message.
 */
export const ListEmailThreadsByEntityResponseSchema: GenMessage<ListEmailThreadsByEntityResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 1);

/**
 * EmailThreadLink is one edge of the polymorphic conversation-to-entity
 * linkage stored in emails.email_thread_links. A thread may carry many links
 * at once (UNIQUE is on thread_id + entity_type + entity_id), so a single
 * conversation can be attached to, say, a Company and a Quote simultaneously.
 * This replaces the special-cased contact_id / inquiry_id columns on
 * EmailThread — do not add further per-entity ID fields there.
 *
 * @generated from message cortado.v1.EmailThreadLink
 */
export type EmailThreadLink = Message<"cortado.v1.EmailThreadLink"> & {
  /**
   * Unique identifier for the link row.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Conversation being linked.
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * Type of CRM entity the conversation is linked to.
   *
   * @generated from field: cortado.v1.ParentTypeEnum entity_type = 10;
   */
  entityType: ParentTypeEnum;

  /**
   * ID of the CRM entity the conversation is linked to.
   *
   * @generated from field: string entity_id = 11;
   */
  entityId: string;

  /**
   * How the link came to exist.
   *
   * @generated from field: cortado.v1.EmailThreadLinkSourceEnum link_source = 50;
   */
  linkSource: EmailThreadLinkSourceEnum;

  /**
   * Created at timestamp.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * Updated at timestamp.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * Human-readable label for the linked entity, for display without a second
   * fetch (optional; empty when the entity could not be resolved).
   *
   * @generated from field: optional string entity_label = 70;
   */
  entityLabel?: string;
};

/**
 * Describes the message cortado.v1.EmailThreadLink.
 * Use `create(EmailThreadLinkSchema)` to create a new message.
 */
export const EmailThreadLinkSchema: GenMessage<EmailThreadLink> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 2);

/**
 * LinkEmailThreadRequest attaches a conversation to a CRM entity. Idempotent:
 * re-linking an existing pair updates the existing row rather than failing.
 *
 * @generated from message cortado.v1.LinkEmailThreadRequest
 */
export type LinkEmailThreadRequest = Message<"cortado.v1.LinkEmailThreadRequest"> & {
  /**
   * Organization the conversation belongs to (required).
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Conversation to link (required).
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * Type of entity to link the conversation to (required).
   *
   * @generated from field: cortado.v1.ParentTypeEnum entity_type = 3;
   */
  entityType: ParentTypeEnum;

  /**
   * ID of the entity to link the conversation to (required).
   *
   * @generated from field: string entity_id = 4;
   */
  entityId: string;
};

/**
 * Describes the message cortado.v1.LinkEmailThreadRequest.
 * Use `create(LinkEmailThreadRequestSchema)` to create a new message.
 */
export const LinkEmailThreadRequestSchema: GenMessage<LinkEmailThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 3);

/**
 * LinkEmailThreadResponse returns the link that was created or refreshed,
 * plus the conversation's full link set after the change.
 *
 * @generated from message cortado.v1.LinkEmailThreadResponse
 */
export type LinkEmailThreadResponse = Message<"cortado.v1.LinkEmailThreadResponse"> & {
  /**
   * The link that was created or refreshed.
   *
   * @generated from field: cortado.v1.EmailThreadLink link = 1;
   */
  link?: EmailThreadLink;

  /**
   * Every link on the conversation after the change.
   *
   * @generated from field: repeated cortado.v1.EmailThreadLink links = 2;
   */
  links: EmailThreadLink[];
};

/**
 * Describes the message cortado.v1.LinkEmailThreadResponse.
 * Use `create(LinkEmailThreadResponseSchema)` to create a new message.
 */
export const LinkEmailThreadResponseSchema: GenMessage<LinkEmailThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 4);

/**
 * UnlinkEmailThreadRequest detaches a conversation from one CRM entity.
 * Removing a link the conversation does not have is not an error.
 *
 * @generated from message cortado.v1.UnlinkEmailThreadRequest
 */
export type UnlinkEmailThreadRequest = Message<"cortado.v1.UnlinkEmailThreadRequest"> & {
  /**
   * Organization the conversation belongs to (required).
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Conversation to unlink (required).
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * Type of entity to detach (required).
   *
   * @generated from field: cortado.v1.ParentTypeEnum entity_type = 3;
   */
  entityType: ParentTypeEnum;

  /**
   * ID of the entity to detach (required).
   *
   * @generated from field: string entity_id = 4;
   */
  entityId: string;
};

/**
 * Describes the message cortado.v1.UnlinkEmailThreadRequest.
 * Use `create(UnlinkEmailThreadRequestSchema)` to create a new message.
 */
export const UnlinkEmailThreadRequestSchema: GenMessage<UnlinkEmailThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 5);

/**
 * UnlinkEmailThreadResponse returns the conversation's remaining links.
 *
 * @generated from message cortado.v1.UnlinkEmailThreadResponse
 */
export type UnlinkEmailThreadResponse = Message<"cortado.v1.UnlinkEmailThreadResponse"> & {
  /**
   * Every link still on the conversation after the change.
   *
   * @generated from field: repeated cortado.v1.EmailThreadLink links = 1;
   */
  links: EmailThreadLink[];
};

/**
 * Describes the message cortado.v1.UnlinkEmailThreadResponse.
 * Use `create(UnlinkEmailThreadResponseSchema)` to create a new message.
 */
export const UnlinkEmailThreadResponseSchema: GenMessage<UnlinkEmailThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 6);

/**
 * ListEmailThreadLinksRequest retrieves every entity a conversation is linked to.
 *
 * @generated from message cortado.v1.ListEmailThreadLinksRequest
 */
export type ListEmailThreadLinksRequest = Message<"cortado.v1.ListEmailThreadLinksRequest"> & {
  /**
   * Organization the conversation belongs to (required).
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Conversation whose links should be returned (required).
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;
};

/**
 * Describes the message cortado.v1.ListEmailThreadLinksRequest.
 * Use `create(ListEmailThreadLinksRequestSchema)` to create a new message.
 */
export const ListEmailThreadLinksRequestSchema: GenMessage<ListEmailThreadLinksRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 7);

/**
 * ListEmailThreadLinksResponse returns the conversation's links.
 *
 * @generated from message cortado.v1.ListEmailThreadLinksResponse
 */
export type ListEmailThreadLinksResponse = Message<"cortado.v1.ListEmailThreadLinksResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailThreadLink links = 1;
   */
  links: EmailThreadLink[];
};

/**
 * Describes the message cortado.v1.ListEmailThreadLinksResponse.
 * Use `create(ListEmailThreadLinksResponseSchema)` to create a new message.
 */
export const ListEmailThreadLinksResponseSchema: GenMessage<ListEmailThreadLinksResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 8);

/**
 * ListEmailThreadEntityCandidatesRequest asks which open work a conversation
 * could be about.
 *
 * @generated from message cortado.v1.ListEmailThreadEntityCandidatesRequest
 */
export type ListEmailThreadEntityCandidatesRequest = Message<"cortado.v1.ListEmailThreadEntityCandidatesRequest"> & {
  /**
   * Organization the conversation belongs to (required).
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Conversation to place (required).
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;
};

/**
 * Describes the message cortado.v1.ListEmailThreadEntityCandidatesRequest.
 * Use `create(ListEmailThreadEntityCandidatesRequestSchema)` to create a new message.
 */
export const ListEmailThreadEntityCandidatesRequestSchema: GenMessage<ListEmailThreadEntityCandidatesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 9);

/**
 * EmailThreadEntityCandidate is one open lead or booking of the
 * conversation's contact. Picking it calls LinkEmailThread with its
 * entity_type and entity_id.
 *
 * @generated from message cortado.v1.EmailThreadEntityCandidate
 */
export type EmailThreadEntityCandidate = Message<"cortado.v1.EmailThreadEntityCandidate"> & {
  /**
   * PARENT_TYPE_INQUIRY or PARENT_TYPE_BOOKING.
   *
   * @generated from field: cortado.v1.ParentTypeEnum entity_type = 1;
   */
  entityType: ParentTypeEnum;

  /**
   * ID of the lead or booking.
   *
   * @generated from field: string entity_id = 2;
   */
  entityId: string;

  /**
   * The lead itself, or the booking's lead.
   *
   * @generated from field: string inquiry_id = 3;
   */
  inquiryId: string;

  /**
   * Event type, for the chip label (optional).
   *
   * @generated from field: optional string event_type = 4;
   */
  eventType?: string;

  /**
   * Earliest event date (optional).
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 5;
   */
  eventDate?: Timestamp;

  /**
   * Stage label, e.g. "Quote sent" or "Upcoming".
   *
   * @generated from field: string stage = 6;
   */
  stage: string;

  /**
   * Whether the conversation is already linked to this candidate.
   *
   * @generated from field: bool linked = 7;
   */
  linked: boolean;
};

/**
 * Describes the message cortado.v1.EmailThreadEntityCandidate.
 * Use `create(EmailThreadEntityCandidateSchema)` to create a new message.
 */
export const EmailThreadEntityCandidateSchema: GenMessage<EmailThreadEntityCandidate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 10);

/**
 * ListEmailThreadEntityCandidatesResponse returns the candidates, soonest
 * event first, and the thread's open review question.
 *
 * @generated from message cortado.v1.ListEmailThreadEntityCandidatesResponse
 */
export type ListEmailThreadEntityCandidatesResponse = Message<"cortado.v1.ListEmailThreadEntityCandidatesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailThreadEntityCandidate candidates = 1;
   */
  candidates: EmailThreadEntityCandidate[];

  /**
   * Why the thread waits in NEEDS_REVIEW (unset when it does not).
   *
   * @generated from field: optional cortado.v1.EmailThreadReviewReason review_reason = 2;
   */
  reviewReason?: EmailThreadReviewReason;
};

/**
 * Describes the message cortado.v1.ListEmailThreadEntityCandidatesResponse.
 * Use `create(ListEmailThreadEntityCandidatesResponseSchema)` to create a new message.
 */
export const ListEmailThreadEntityCandidatesResponseSchema: GenMessage<ListEmailThreadEntityCandidatesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 11);

/**
 * MarkEmailThreadReadRequest advances the current user's read position.
 *
 * @generated from message cortado.v1.MarkEmailThreadReadRequest
 */
export type MarkEmailThreadReadRequest = Message<"cortado.v1.MarkEmailThreadReadRequest"> & {
  /**
   * Organization the conversation belongs to.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Conversation to mark read.
   *
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * Latest thread message boundary the client actually rendered.
   *
   * @generated from field: google.protobuf.Timestamp read_through = 3;
   */
  readThrough?: Timestamp;
};

/**
 * Describes the message cortado.v1.MarkEmailThreadReadRequest.
 * Use `create(MarkEmailThreadReadRequestSchema)` to create a new message.
 */
export const MarkEmailThreadReadRequestSchema: GenMessage<MarkEmailThreadReadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 12);

/**
 * MarkEmailThreadReadResponse returns the exact server read position and updated unread count.
 *
 * @generated from message cortado.v1.MarkEmailThreadReadResponse
 */
export type MarkEmailThreadReadResponse = Message<"cortado.v1.MarkEmailThreadReadResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp marked_read_at = 1;
   */
  markedReadAt?: Timestamp;

  /**
   * @generated from field: int32 unread_count = 2;
   */
  unreadCount: number;
};

/**
 * Describes the message cortado.v1.MarkEmailThreadReadResponse.
 * Use `create(MarkEmailThreadReadResponseSchema)` to create a new message.
 */
export const MarkEmailThreadReadResponseSchema: GenMessage<MarkEmailThreadReadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 13);

/**
 * EmailThreadAddressSuggestion offers an address on a conversation to a
 * contact linked to it, because it was sent under that contact's name.
 *
 * @generated from message cortado.v1.EmailThreadAddressSuggestion
 */
export type EmailThreadAddressSuggestion = Message<"cortado.v1.EmailThreadAddressSuggestion"> & {
  /**
   * The unmatched address, lowercased.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * The name the address was sent with.
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * The linked contact the address may belong to.
   *
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * That contact's full name.
   *
   * @generated from field: string contact_name = 4;
   */
  contactName: string;
};

/**
 * Describes the message cortado.v1.EmailThreadAddressSuggestion.
 * Use `create(EmailThreadAddressSuggestionSchema)` to create a new message.
 */
export const EmailThreadAddressSuggestionSchema: GenMessage<EmailThreadAddressSuggestion> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 14);

/**
 * @generated from message cortado.v1.ListEmailThreadAddressSuggestionsRequest
 */
export type ListEmailThreadAddressSuggestionsRequest = Message<"cortado.v1.ListEmailThreadAddressSuggestionsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string thread_id = 2;
   */
  threadId: string;
};

/**
 * Describes the message cortado.v1.ListEmailThreadAddressSuggestionsRequest.
 * Use `create(ListEmailThreadAddressSuggestionsRequestSchema)` to create a new message.
 */
export const ListEmailThreadAddressSuggestionsRequestSchema: GenMessage<ListEmailThreadAddressSuggestionsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 15);

/**
 * @generated from message cortado.v1.ListEmailThreadAddressSuggestionsResponse
 */
export type ListEmailThreadAddressSuggestionsResponse = Message<"cortado.v1.ListEmailThreadAddressSuggestionsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.EmailThreadAddressSuggestion suggestions = 1;
   */
  suggestions: EmailThreadAddressSuggestion[];
};

/**
 * Describes the message cortado.v1.ListEmailThreadAddressSuggestionsResponse.
 * Use `create(ListEmailThreadAddressSuggestionsResponseSchema)` to create a new message.
 */
export const ListEmailThreadAddressSuggestionsResponseSchema: GenMessage<ListEmailThreadAddressSuggestionsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 16);

/**
 * @generated from message cortado.v1.AcceptEmailThreadAddressSuggestionRequest
 */
export type AcceptEmailThreadAddressSuggestionRequest = Message<"cortado.v1.AcceptEmailThreadAddressSuggestionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;
};

/**
 * Describes the message cortado.v1.AcceptEmailThreadAddressSuggestionRequest.
 * Use `create(AcceptEmailThreadAddressSuggestionRequestSchema)` to create a new message.
 */
export const AcceptEmailThreadAddressSuggestionRequestSchema: GenMessage<AcceptEmailThreadAddressSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 17);

/**
 * @generated from message cortado.v1.AcceptEmailThreadAddressSuggestionResponse
 */
export type AcceptEmailThreadAddressSuggestionResponse = Message<"cortado.v1.AcceptEmailThreadAddressSuggestionResponse"> & {
  /**
   * The contact with its addresses after the change.
   *
   * @generated from field: cortado.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message cortado.v1.AcceptEmailThreadAddressSuggestionResponse.
 * Use `create(AcceptEmailThreadAddressSuggestionResponseSchema)` to create a new message.
 */
export const AcceptEmailThreadAddressSuggestionResponseSchema: GenMessage<AcceptEmailThreadAddressSuggestionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 18);

/**
 * @generated from message cortado.v1.DismissEmailThreadAddressSuggestionRequest
 */
export type DismissEmailThreadAddressSuggestionRequest = Message<"cortado.v1.DismissEmailThreadAddressSuggestionRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message cortado.v1.DismissEmailThreadAddressSuggestionRequest.
 * Use `create(DismissEmailThreadAddressSuggestionRequestSchema)` to create a new message.
 */
export const DismissEmailThreadAddressSuggestionRequestSchema: GenMessage<DismissEmailThreadAddressSuggestionRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 19);

/**
 * @generated from message cortado.v1.DismissEmailThreadAddressSuggestionResponse
 */
export type DismissEmailThreadAddressSuggestionResponse = Message<"cortado.v1.DismissEmailThreadAddressSuggestionResponse"> & {
};

/**
 * Describes the message cortado.v1.DismissEmailThreadAddressSuggestionResponse.
 * Use `create(DismissEmailThreadAddressSuggestionResponseSchema)` to create a new message.
 */
export const DismissEmailThreadAddressSuggestionResponseSchema: GenMessage<DismissEmailThreadAddressSuggestionResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_email_conversations, 20);

